import { EnumObject } from './enum-object';

export const BaseConnectionType = {
  Application: 'application',
  Invitation: 'invitation',
  Offline: 'Offline Match',
} as const;

export const BASE_CONNECTION_TYPE_I18N: Record<BaseConnectionType, string> = {
  [BaseConnectionType.Application]: 'Bewerbung',
  [BaseConnectionType.Invitation]: 'Einladung',
  [BaseConnectionType.Offline]: 'Offline Match',
};

export type BaseConnectionType = EnumObject<typeof BaseConnectionType>;
